module.exports = __webpack_public_path__ + "media/store/images/logo-fbb98d6cea0b7faa8ee93ab5a3bce4a9.svg";